import api from "@services/api-service";

const store = {
  // ////////////////////////////////////////////
  // STATE
  // ////////////////////////////////////////////

  state: {
    loading: false,
    data: []
  },

  // ////////////////////////////////////////////
  // MUTATIONS
  // ////////////////////////////////////////////

  mutations: {
    SET_TIPO_CONTRATO_LOADING: (state, isLoading) => {
      state.tipoContrato.loading = isLoading;
    },

    SET_TIPOS_CONTRATO: (state, tiposPagamento) => {
      state.tipoContrato.data = tiposPagamento;
    }
  },

  // ////////////////////////////////////////////
  // GETTERS
  // ////////////////////////////////////////////

  getters: {
    fetchTiposContrato: () => () => new Promise((resolve, reject) => {
      api().get(`tipos-contrato`).then(response => {
        if (response.data.status) {
          resolve(response.data.data);
        }

        reject(response);
      })
    }),





    getTiposContrato: state => id => {
      if (id) {
        let tipoContrato = state.tipoContrato.data.filter(
          tipoContrato => tipoContrato.id == id
        );

        return tipoContrato.length > 0 ? tipoContrato[0] : null;
      }

      return state.tipoContrato.data;
    },

    getTipoContratoPadrao: state => () => {
      let padroes = state.tipoContrato.data.filter(t => {
        return t.padrao === true;
      });

      return padroes.shift();
    }
  },

  // ////////////////////////////////////////////
  // ACTIONS
  // ////////////////////////////////////////////

  actions: {
    FETCH_TIPO_CONTRATO: function ({ commit, state }) {
      // Se ja esta buscando ou se ja foi carregado
      if (state.tipoContrato.loading) return;

      commit("SET_TIPO_CONTRATO_LOADING", true);

      api()
        .get("tipos-contrato")
        .then(response => {
          if (response.data.status) {
            commit("SET_TIPOS_CONTRATO", response.data.data);
          }
        })
        .finally(() => commit("SET_TIPO_CONTRATO_LOADING", false));
    }
  }
};

export default store;
